import { render } from "./XIconSolidClipboardList.vue?vue&type=template&id=431e6970"
import script from "./XIconSolidClipboardList.vue?vue&type=script&lang=js"
export * from "./XIconSolidClipboardList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidClipboardList.vue"]])

export default __exports__